import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/utils";

type Props = {
  label: string;
  icon?: React.ReactNode;
  error?: string;
  trailingElement?: React.ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

export const LoginFormField = forwardRef<HTMLInputElement, Props>(
  ({ label, icon, error, trailingElement, className, ...inputProps }, ref) => (
    <div className="mb-2 lg:mb-3.5">
      <label className="block text-[clamp(0.8rem,0.9vw,1rem)] font-medium text-[#374151] mb-1">
        {label}
      </label>
      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 flex text-[#9CA3AF]">
            {icon}
          </span>
        )}
        <input
          ref={ref}
          className={cn(
            "w-full border border-[#E5E7EB] rounded-lg bg-white text-[#111827] outline-none transition-[border-color,box-shadow] duration-150",
            "py-2 lg:py-[clamp(0.65rem,0.9vw,0.95rem)] pr-3.5 text-[clamp(0.875rem,0.95vw,1.05rem)]",
            icon ? "pl-[2.4rem]" : "pl-3.5",
            trailingElement && "pr-10",
            "focus:border-brand-pink focus:ring-[3px] focus:ring-brand-pink/20",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            error && "border-red-400",
            className,
          )}
          {...inputProps}
        />
        {trailingElement && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 flex">
            {trailingElement}
          </div>
        )}
      </div>
      {error && <p className="text-red-500 text-[0.75rem] mt-1">{error}</p>}
    </div>
  )
);
LoginFormField.displayName = "LoginFormField";
